import Marks from './Marks';
import isEndOfNode from './isEndOfNode';

// this function selects all letter in a word from cursor to upto the end of word
const selectFromCursorToEnd = (editor) => {
  editor.moveFocusForward(1);
  let { fragment: fragment1 } = editor.value;
  while (
    Marks[fragment1.text.charAt(fragment1.text.length - 1)] !== true &&
    !isEndOfNode(editor)
  ) {
    editor.moveFocusForward(1);
    const { fragment: tempFragment } = editor.value;
    fragment1 = tempFragment;
  }
  let { fragment: fragment2 } = editor.value;
  if (Marks[fragment2.text.charAt(fragment2.text.length - 1)] === true) {
    editor.moveFocusBackward(1);
    const { fragment: tempFragment } = editor.value;
    fragment2 = tempFragment;
  }
};

export default selectFromCursorToEnd;
